import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {Observable} from 'rxjs';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {UmpireImage} from '@tisa-group/models';

@Injectable()
export class ImageService implements CrudService<UmpireImage> {
  constructor(readonly http: TisaUmpireHttpService) {}

  create(
    body: Partial<UmpireImage>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireImage>> {
    return this.http
      .post(`/images`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireImage>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireImage>> {
    return this.http
      .patch(`/images/${body.id}`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }
}
